// extracted by mini-css-extract-plugin
export var chevronIcon = "_db-2";
export var teamName = "_db-1";
export var teamSwitcherButton = "_db-0";